import InputNumber from './input-number.vue';
export default InputNumber;


// WEBPACK FOOTER //
// ./src/components/input-number/index.js